import { useState } from 'react';
import { forgotPassword } from '@/services/api/User';

const useForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSuccess, setIsSuccess] = useState(false);

  const requestResetPassword = async () => {
    if (isLoading) return;
    setErrors({})
    if (!email) {
      setErrors({ email: 'Email is required' });
    }

    setIsLoading(true);
    try {
      await forgotPassword({ email });
      setIsSuccess(true);
    } catch (error) {
      if (error.response?.data?.message == 'User does not exist') {
        console.log(error.response.data.message)
        setErrors({ 'message': 'User does not exist!' });
      } else {
        setErrors({ 'message': 'An error occured. Please try again!' });
      }
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    email,
    setEmail,
    isLoading,
    requestResetPassword,
    isSuccess,
    errors,
  };
}

export default useForgotPassword;
